import api from './apiConfig';

export const widgetService = {
    getAll: async () => {
      const response = await api.get('/ui/widgets');
      console.log('Widgets API response:', response.data);
      return response.data;
    },
    getData: async (id, params = {}) => {
      const response = await api.get(`/ui/widgets/${id}/data`, { params });
      console.log('Widget data API response:', { id, params, data: response.data });
      return response.data;
    }
  }; 

export default widgetService;